import React, { useEffect, useState } from "react";
import "./PinPointButtons.css";
function PinPointButtons(props) {
  const [addPinPointsButtonClicked, setAddPinPointsButtonClicked] =
    useState(false);
  const [updatePinPointsButtonClicked, setUpdatePinPointsButtonClicked] =
    useState(false);
  const [deletePinPointsButtonClicked, setDeletePinPointsButtonClicked] =
    useState(false);
  const [hideShowButtonClicked, setHideShowButtonClicked] = useState(true);

  useEffect(() => {
    setHideShowButtonClicked(props.hideShowDataRef.current.hideShow);
  }, []);
  return (
    <div className="pin-point-buttons">
      <button
        className="pin-point-button"
        onClick={() => {
          props.addPinPointsButtonClickedRef.current =
            !props.addPinPointsButtonClickedRef.current;
          setAddPinPointsButtonClicked(!addPinPointsButtonClicked);
        }}
        style={
          addPinPointsButtonClicked
            ? { backgroundColor: "#0dcaf0", color: "#edffff" }
            : {}
        }
      >
        Add PinPoints
      </button>
      <button
        className="pin-point-button"
        onClick={() => {
          props.updatePinPointsButtonClickedRef.current =
            !props.updatePinPointsButtonClickedRef.current;
          setUpdatePinPointsButtonClicked(!updatePinPointsButtonClicked);
        }}
        style={
          updatePinPointsButtonClicked
            ? { backgroundColor: "#0dcaf0", color: "#edffff" }
            : {}
        }
      >
        Update PinPoints
      </button>
      <button
        className="pin-point-button"
        onClick={() => {
          props.deletePinPointsButtonClickedRef.current =
            !props.deletePinPointsButtonClickedRef.current;
          setDeletePinPointsButtonClicked(!deletePinPointsButtonClicked);
        }}
        style={
          deletePinPointsButtonClicked
            ? { backgroundColor: "#0dcaf0", color: "#edffff" }
            : {}
        }
      >
        Delete PinPoints
      </button>
      <button
        className="pin-point-button"
        onClick={() => {
          setHideShowButtonClicked(!hideShowButtonClicked);
          props.hideShowDataRef.current.setHideShow(!hideShowButtonClicked);
        }}
      >
        {hideShowButtonClicked ? "Hide Layers" : "Show Layers"}
      </button>
    </div>
  );
}

export default PinPointButtons;
